'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EEStyles(_ref) {
  var themeVersion = _ref.themeVersion;

  (0, _react.useEffect)(function () {
    var link = document.createElement('link');
    link.rel = 'stylesheet';

    var _window = window,
        EEContext = _window.EEContext;

    var cloudPath = EEContext.environment.isCloud ? '/extranet' : '';
    var baseUrl = EEContext.environment.baseCdnUrl + cloudPath;
    var theme = EEContext.experience.theme.toLowerCase();
    var version = EEContext.corpoContentVersion;

    link.href = baseUrl + '/styles/' + theme + '/' + themeVersion + '/extranet.css?version=' + version;

    document.head.appendChild(link);
  }, [themeVersion]);

  return null;
}

EEStyles.defaultProps = {
  themeVersion: '2'
};

EEStyles.propTypes = {
  themeVersion: _propTypes2.default.string
};

exports.default = EEStyles;